// import React from 'react';
// import loadable from '@loadable/component';

// import { bool, object } from 'prop-types';
// import { compose } from 'redux';
// import { connect } from 'react-redux';

// import { camelize } from '../../util/string';
// import { propTypes } from '../../util/types';

// import FallbackPage from './FallbackPage';
// import { ASSET_NAME } from './LandingPage.duck';
// import { withRouter } from 'react-router-dom';

// const PageBuilder = loadable(() =>
//   import(/* webpackChunkName: "PageBuilder" */ '../PageBuilder/PageBuilder')
// );

// export const LandingPageComponent = props => {
//   const { pageAssetsData, inProgress, error, history } = props;
//   // console.log(1211, props, history);
//   return (
//     <PageBuilder
//       pageAssetsData={pageAssetsData?.[camelize(ASSET_NAME)]?.data}
//       inProgress={inProgress}
//       error={error}
//       fallbackPage={<FallbackPage error={error} />}
//       history={history}
//     />
//   );
// };

// LandingPageComponent.propTypes = {
//   pageAssetsData: object,
//   inProgress: bool,
//   error: propTypes.error,
// };

// const mapStateToProps = state => {
//   const { pageAssetsData, inProgress, error } = state.hostedAssets || {};
//   return { pageAssetsData, inProgress, error };
// };

// // Note: it is important that the withRouter HOC is **outside** the
// // connect HOC, otherwise React Router won't rerender any Route
// // components since connect implements a shouldComponentUpdate
// // lifecycle hook.
// //
// // See: https://github.com/ReactTraining/react-router/issues/4671
// const LandingPage = compose(withRouter, connect(mapStateToProps))(LandingPageComponent);

// export default LandingPage;

import React, { useEffect } from 'react';
import loadable from '@loadable/component';

import { bool, object } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { camelize } from '../../util/string';
import { propTypes } from '../../util/types';

import FallbackPage from './FallbackPage';
import { ASSET_NAME } from './LandingPage.duck';
import { withRouter } from 'react-router-dom';
import { createResourceLocatorString } from '../../util/routes';
import { useRouteConfiguration } from '../../context/routeConfigurationContext';
import { Page } from '../../components';
import { isScrollingDisabled } from '../../ducks/ui.duck';
import {
  exposeContentString,
  exposeOpenGraphData,
} from '../PageBuilder/Field/Field.helpers';

const PageBuilder = loadable(() =>
  import(/* webpackChunkName: "PageBuilder" */ '../PageBuilder/PageBuilder')
);

const isDevServer = !!process.env.REACT_APP_IS_DEV_SERVER;

// Pick the SEO data (title, description, social sharing) from the landing page asset.
// Mirrors getMetadata in PageBuilder.js without pulling the whole PageBuilder into this chunk.
const getMetadata = meta => {
  const { pageTitle, pageDescription, socialSharing } = meta || {};
  const title = pageTitle ? exposeContentString(pageTitle).content : null;
  const description = pageDescription ? exposeContentString(pageDescription).content : null;
  const openGraph = socialSharing ? exposeOpenGraphData(socialSharing) : null;
  const schemaImage = openGraph?.images1200?.[0]?.url;
  const schemaImageMaybe = schemaImage ? { image: [schemaImage] } : {};

  return {
    title,
    description,
    socialSharing: openGraph,
    schema: {
      '@context': 'http://schema.org',
      '@type': 'WebPage',
      description,
      name: title,
      ...schemaImageMaybe,
    },
  };
};

export const LandingPageComponent = props => {
  const { pageAssetsData, inProgress, error, isAuthenticated, history, scrollingDisabled } = props;
  const routeConfiguration = useRouteConfiguration();

  useEffect(() => {
    if (isAuthenticated) {
      history.push(
        createResourceLocatorString('SearchPage', routeConfiguration, {}, { mobilesearch: true })
      );
    } else {
      // if (typeof window !== 'undefined' && !isDevServer)
      if (typeof window !== 'undefined') window.location.href = 'https://adventurely.app';
    }
  }, [isAuthenticated]);

  // This page always redirects, so the body stays empty to avoid a flash of the old landing page.
  // <Page> still renders the <head> tags on the server, so crawlers and link previews get the SEO data.
  const pageMetaProps = getMetadata(pageAssetsData?.[camelize(ASSET_NAME)]?.data?.meta);
  return <Page {...pageMetaProps} scrollingDisabled={scrollingDisabled} />;

  // return (
  //   <PageBuilder
  //     pageAssetsData={pageAssetsData?.[camelize(ASSET_NAME)]?.data}
  //     inProgress={inProgress}
  //     error={error}
  //     fallbackPage={<FallbackPage error={error} />}
  //   />
  // );
};

LandingPageComponent.propTypes = {
  pageAssetsData: object,
  inProgress: bool,
  error: propTypes.error,
};

const mapStateToProps = state => {
  const { isAuthenticated } = state.auth;
  const { pageAssetsData, inProgress, error } = state.hostedAssets || {};

  return {
    pageAssetsData,
    inProgress,
    error,
    isAuthenticated,
    scrollingDisabled: isScrollingDisabled(state),
  };
};

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const LandingPage = compose(connect(mapStateToProps), withRouter)(LandingPageComponent);

export default LandingPage;
